/*
<summary>
    This functional common component provides modal popup that shows delete confirmation message (i.e. are you sure want to delete).
    Developer:Mohammad Saquib Khan, Created Date:04-April-2024
</summary>
<returns>Returns JSX</returns>
*/
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import LoaderButton from '../../button/loader-button';
import './delete-popup.css';
interface Props {
  modalSubmit: () => void;
  modalClosed: () => void;
  isLoading: boolean;
  title: string;
  message?: string;
  id?: string;
}

const DeletePopup: React.FC<Props> = (props) => {
  return (
    <Modal
      show={true}
      centered
      dialogClassName="delete_popup"
      onHide={() => {}}
    >
      <Modal.Body className="p-5">
        {/* <img
          src={deleteImages}
          alt="logo"
          className="img-fluid"
        ></img> */}
        <Modal.Title className="my-3 ">
          <FormattedMessage id={props.title} /> <h3 className='delet_trayId mt-1'>{props.id ?  `${props.id}` : ''} </h3>
        </Modal.Title>
        <div className="bootbox-body">
          <FormattedMessage id={props.message} />
        </div>
      </Modal.Body>
      <Modal.Footer className="">
        <Button
          variant="light-danger"
          onClick={props.modalClosed}
          disabled={props.isLoading}
          className="btnOkSize"
        >
          <FormattedMessage id="cancel" />
        </Button>
        <LoaderButton
          type="submit"
          onClick={props.modalSubmit}
          isLoading={props.isLoading}
          text="button_delete"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default DeletePopup;
